// see https://github.com/codemirror/CodeMirror/issues/5403#issuecomment-392852397
import CodeMirror from "codemirror/src/codemirror.js"
window.CodeMirror = CodeMirror
